import { UserRole } from '@feedyou/schema'
import { rolesArray } from '../../../constants/roles'

// turns "comment" into { comment: true, view: true, edit: false, admin: false }
export function expandRole(targetRole: UserRole): Record<UserRole, boolean> {
  const targetRoleIndex = rolesArray.findIndex(role => role === targetRole)

  return Object.fromEntries(
    // I <3 PRETTIER
    rolesArray.map((role, index) => [role, index <= targetRoleIndex])
  ) as Record<UserRole, boolean>
}
